<template>
  <div data-v-87bd734a="" role="group" class="form-group">
    <label for="uid-zfhimt9xoce" class="">{{label}}</label>
    <div id="drop-area" ref="dropArea">
      <form class="my-form">
        <p>{{placeholder}}</p>
        <input type="file" id="fileElem" ref="fileElem" multiple accept="" @change="()=>handleFiles($refs.fileElem.files)">
        <label class="buttonInput" for="fileElem">Buscar archivos</label>
      </form>
        <div :class="typeView">
          <div class="container-item" v-for="(file,i) in filesSrc" :key="file.media">
            <i class="fa fa-trash" @click="deleteFile(i)"></i>
            <img :src="file.src" :alt="file.src?file.name:''" @click="()=>setPreview(file)" />
            <span @click="()=>setPreview(file)">{{file.name}}</span>
          </div>
        </div>
        <div v-if="preview" class="preview-item">
          <i class="fa fa-times" @click="()=>setPreview(null)"></i>
          <div class="media" v-if="preview.type.includes('image')">
            <img ref="velo_img" :src="preview.src" :alt="preview.src?preview.name:''">
            <div class="velo" :style="`--width:${dimencion.width||0}px;--height:${dimencion.height||0}px`" @click="printImg">
                <i class="fa fa-download"></i>
            </div>
          </div>
          <iframe :src="preview.fileSrc" frameborder="0" class="media" v-else></iframe>
        </div>
    </div>
  </div>
</template>

<script>
  import fileImg from '@/assets/images/file.png'
    export default {
        name: "KlayFileDD",
        props: {
          value: {
              type: Array,
              default: ()=>[]
          },
          fetching: {
              type: Boolean,
              default: false
          },
          fetchMethod: {
              type: Function,
              required: true
          },
          typeView: {
              type: String,
              default: 'list'
          },
          label: {
              type: String,
              default: ''
          },
          baseSrc: {
              type: String,
              default: ''
          },
          placeholder: {
              type: String,
              default: "Cargue varios archivos con el cuadro de diálogo de archivo o arrastrando y soltando imágenes en la región discontinua" 
          },
        },
        computed: {
            progressBar() {
                return document.getElementById('progress-bar')
            },
        },
        watch: {
          '$refs.velo_img'(newV,){
            console.log(newV)
            debugger
          },
          fetching(newV,){
            return newV?this.fetchMethod(this.files).then(medias=>{
              console.log(medias)
              this.$emit("onFetch",[...medias])
              this.$emit("input",[...medias])
              this.$emit("change",[...medias])
              this.files = []
            }).catch(err=>{
              this.$emit("onErrorFetch",err.message)
            }):false
          },
          value: {
            immediate: true,
            handler: function(newV,){
              this.files = [...newV]
            }
          },
          files: {
            immediate: true,
            handler: function(newValue, ) {
              this.filesSrc = newValue.map((m,i)=>{
                  const file = this.filesSrc[i]??{src:"",name:m.name,type: m.type}
                  if(!file.src&&!m.media){
                    this.previewFile(m)
                      .then(([src,fileSrc])=>{
                        this.filesSrc[i].media = `${i}_`
                        this.filesSrc[i].src = src
                        this.filesSrc[i].fileSrc = fileSrc
                        this.$forceUpdate();
                      })
                  }
                  if(!file.src&&m.media){
                    file.media = m.media
                    file.src = m.mime_type.includes('image')?(this.baseSrc + m.media):fileImg
                    file.fileSrc = this.baseSrc + m.media
                    file.name = m.name
                    file.type = m.mime_type
                  }
                  return file
              })
            }
          }
        },
        data() {
            return {
                preview: null,
                filesDone: 0,
                filesToDo: 0,
                uploadProgress: [],
                files: [],
                filesSrc:[],
                dimencion: {},
            }
        },
        mounted () {
            let dropArea = this.$refs.dropArea

            ;['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
               dropArea.addEventListener(eventName, e=>{
                e.preventDefault()
                e.stopPropagation()
                }, false)
            })
            ;['dragenter', 'dragover'].forEach(eventName => {
                dropArea.addEventListener(eventName, ()=>dropArea.classList.add('highlight'), false)
            })

            ;['dragleave', 'drop'].forEach(eventName => {
                dropArea.addEventListener(eventName, ()=>dropArea.classList.remove('highlight'), false)
            })
            dropArea.addEventListener('drop', e=>{
                const dt = e.dataTransfer
                const files = dt.files

                this.handleFiles(files)
            }, false)

        },
        methods: {
            setPreview(item){
              
              if(!item||item.type.match(/(image|pdf)/)){
                if(item){
                  setTimeout(()=>{
                    this.dimencion = {
                      width:this.$refs.velo_img.offsetWidth,
                      height:this.$refs.velo_img.offsetHeight
                    }
                  },100)
                }
                this.preview = item
                return
              }
              if (window.confirm(`¿Quieres descargar el archivo ${item.name}?`)) {
                const a = document.createElement('a')
                a.href = item.fileSrc
                a.download = true
                a.target = '_blank'
                a.click()
              }
            },
            deleteFile(index){
              this.filesSrc.splice(index,1)
              this.files.splice(index,1)
            },
            handleFiles(files) {
                //debugger
                //(file.type.match(/image.*/))
                this.files = [...this.files,...files]
            },
            previewFile(file) {
              return new Promise((resolve,reject)=>{
                const reader = new FileReader()
                reader.onerror = function(){
                  reject(reader.error)
                  reader.abort();
                }
                reader.onloadend = function() {
                  const tes = [file.type.includes('image')?reader.result:fileImg,reader.result]
                  resolve(tes)
                }
                reader.readAsDataURL(file)
              })
               
            },
            progressDone() {
                this.filesDone++
                this.progressBar.value = this.filesDone / this.filesToDo * 100
            },
            updateProgress(fileNumber, percent) {
                this.uploadProgress[fileNumber] = percent
                let total = this.uploadProgress.reduce((tot, curr) => tot + curr, 0) / this.uploadProgress.length
                this.progressBar.value = total
            },
            printImg(){
              const a = window.open('', '', `height=${this.dimencion.height}, width=${this.dimencion.width}`);
              a.document.write(`<html><body style="margin: 0px;  height: 100%"><img style="display: block;-webkit-user-select: none;margin: auto;background-color: hsl(0, 0%, 90%);transition: background-color 300ms;" src="${this.preview.src}"></body></html>`);
              setTimeout(() => {
                
                a.document.close();
                a.print();
              }, 100);
            }
        },//
    }
</script>

<style lang="scss" scoped>
body {
	font-family: sans-serif;
}
a {
	color: #369;
}
.note {
	width: 500px;
	margin: 50px auto;
	font-size: 1.1em;
	color: #333;
	text-align: justify;
}
#drop-area {
	border: 2px dashed #ccc;
	border-radius: 20px;
	width: 100%;
	padding: 20px;
}
#drop-area.highlight {
	border-color: purple;
}
p {
	margin-top: 0;
}
.my-form {
	margin-bottom: 10px;
  text-align: center;
}
.gallery {
	margin-top: 10px;
	display: flex;
	flex-wrap: wrap;
	.container-item {
    &:hover span{
      display: unset;
    }
		position: relative;
		width: 125px;
    height: 125px;
		margin-bottom: 10px;
		margin-right: 10px;
		vertical-align: middle;
		i {
			position: absolute;
			right: 0px;
			cursor: pointer;
      color: #8d0000;
      font-size: 18px;
      z-index: 2;
		}
		img {
			width: 100%;
      height: 100%;
      object-fit: contain;
		}
    span{
      position: absolute;
      top: 0;
      left: 0;
      background: #172b4d82;
      width: 100%;
      height: 100%;
      padding: 10px;
      color: #fff;
      font-weight: bold;
      overflow: hidden;
      border-radius: 10px;
      display: none;
      cursor: pointer;
    }
	}
}
.list {
  position: relative;
	width: 100%;
	.container-item {
    display: grid;
		width: 100%;
    grid-template-columns: 30px 1fr 20px;
    grid-template-rows: 30px;
    grid-template-areas: "img text del";
    align-items: center;
		i {
			grid-area: del;
      cursor: pointer;
      color: #8d0000;
      font-size: 18px;
		}
		img {
      grid-area: img;
			width: 90%;
      height: 90%;
      object-fit: contain;
		}
    span{
      grid-area: text;
      font-weight: bold;
      overflow: hidden;
      border-radius: 10px;
      white-space: nowrap;
      text-overflow: ellipsis;
      cursor: pointer;
    }
	}
}
.buttonInput {
	display: inline-block;
	padding: 10px;
	background: #ccc;
	cursor: pointer;
	border-radius: 5px;
	border: 1px solid #ccc;
	&:hover {
		background: #ddd;
	}
}
#fileElem {
	display: none;
}
.preview-item{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1030;
  background: #00000085;
  display: grid;
  grid-template-rows: 20px calc(100vh - 40px) 20px;
  grid-template-columns:  1fr 20px;
  grid-template-areas: "del ." "img img" ". .";
  justify-items: center;
  .media{
    $dimension: 100px;
  
    grid-area: img;
    width: 90%;
    height: 90%;
    object-fit: contain;
    display: grid;
    place-content: center;
    position: relative;
    .velo{
       display: grid;
        width: var(--width);
        height: var(--height);
        position: absolute;
        left: calc(50% - var(--width)/2);
        top: calc(50% - var(--height)/2);
        *{
          display: none;
        }
    }
    .velo:hover{
        place-content: center;
        background: rgba(1,1,1,.5);
        *{
          display: unset;
        }
        i{
          position: unset;
          font-size: 4rem;
        }
      }
    // &:hover{
    //   .velo{
    //     display: grid;
    //     place-content: center;
    //     background: rgba(1,1,1,.5);
    //     width: var(--width);
    //     height: var(--height);
    //     position: absolute;
    //     left: calc(50% - var(--width)/2);
    //     top: calc(50% - var(--height)/2);
    //     i{
    //       position: unset;
    //       font-size: 4rem;
    //     }
    //   }
    // }
  }
  i{
    grid-area: del;
    position: absolute;
    right: 0;
    cursor: pointer;
    color: #fff;
    font-size: 22px;
  }
}
</style>